import { HTMLAttributes, PropsWithChildren, forwardRef, ForwardedRef } from 'react';

type Alignment =
  | 'flex-start'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'center'
  | 'normal'
  | 'left'
  | 'right'
  | 'stretch';

export interface FlexProps extends HTMLAttributes<HTMLDivElement> {
  display?: 'flex' | 'inline-flex';
  direction?: 'row' | 'column' | 'column-reverse' | 'row-reverse';
  gap?: number;
  justify?: Alignment;
  align?: Alignment;
  wrap?: 'wrap' | 'nowrap';
}

const Flex = (
  {
    display = 'flex',
    direction = 'row',
    gap,
    justify = 'normal',
    align = 'normal',
    style,
    wrap,
    ...props
  }: PropsWithChildren<FlexProps>,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  return (
    <div
      ref={ref}
      style={{
        display,
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align,
        gap: gap != null ? `${gap}px` : undefined,
        flexWrap: wrap,
        ...style,
      }}
      {...props}
    />
  );
};

const FlexWithRef = forwardRef(Flex);
export { FlexWithRef as Flex };
